import lastnameSettings from './settings';
import { generateUseUseSettings } from '../../hooks/generateUseUsingSettings';

export const useUsingLastnameSettings = generateUseUseSettings(lastnameSettings);